import React, { useEffect, useMemo, useState } from "react";
import { Navigation } from "../components/navigation";
import { Footer } from "../components/footer";
import "./faq/faq.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL ?? "";

const normalizeFaq = (faq) => ({
  ...faq,
  id: faq.id ?? faq._id ?? String(faq.question ?? `${Math.random()}`),
  status: (faq.status ?? "draft").toLowerCase(),
});

const requestJson = async (path, config = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      "Content-Type": "application/json",
    },
    ...config,
  });

  if (!response.ok) {
    const payload = await response.text();
    const errorMessage =
      payload && payload.length < 500 ? payload : response.statusText;
    throw new Error(errorMessage);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
};

const FaqPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeFaqId, setActiveFaqId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const fetchFaqs = async () => {
    setLoading(true);
    try {
      const data = await requestJson("/faqs");
      setFaqs((Array.isArray(data) ? data : []).map(normalizeFaq));
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const toggleFaq = (faq) => {
    setActiveFaqId((current) => (current === faq.id ? null : faq.id));
  };

  const totalFaqs = useMemo(() => faqs.length, [faqs]);

  return (
    <>
      <Navigation />
      <main className="faq-page">
        <div className="faq-hero">
          <h1>အမေးအဖြေများ</h1>
          <p>
            Keep your community informed with the latest answers, status
            updates, and explanations for every critical question.
          </p>
        </div>

        <div className="faq-layout">
          <section className="faq-column faq-list">
            <div className="faq-column__header">
              <div>
                <h2>
                  အမေးအဖြေများ{" "}
                  <span className="faq-column__count">({totalFaqs})</span>
                </h2>
              </div>
            </div>

            {errorMessage && (
              <div className="faq-error" role="alert">
                {errorMessage}
              </div>
            )}

            <div className="faq-accordion">
              {loading && (
                <div className="faq-loading">Loading FAQ entries…</div>
              )}

              {!loading && faqs.length === 0 && (
                <div className="faq-empty">No FAQ entries yet.</div>
              )}

              {faqs.map((faq) => {
                const isActive = activeFaqId === faq.id;
                return (
                  <article
                    key={faq.id}
                    className={`faq-item ${isActive ? "faq-item--expanded" : ""}`}
                  >
                    <button
                      type="button"
                      className="faq-item__trigger"
                      aria-expanded={isActive}
                      aria-controls={`faq-panel-${faq.id}`}
                      onClick={() => toggleFaq(faq)}
                    >
                      <div>
                        <p className="faq-item__question">
                          မေး။ ။ {faq.question}
                        </p>
                      </div>
                      <span className="faq-item__toggle">
                        {isActive ? "—" : "+"}
                      </span>
                    </button>

                    {isActive && (
                      <div
                        className="faq-item__panel"
                        id={`faq-panel-${faq.id}`}
                      >
                        <p className="faq-item__answer">ဖြေ။ ။ {faq.answer}</p>
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default FaqPage;
